import {i18n} from '@/plugins/i18n';
import action from "./actions.vue";

const routerLink = (id, route_name, title) => {
    let template = new action({
        props: {
            id,
            route_name,
            title
        }
    })

    template.id = id
    template.route_name = route_name
    template.title = title
    return template.$mount().$el
}
export default [
    {
        field: 'user',
        title: i18n.t('label.user_full_name'),
        width: 90,
        template:(row) => {
            return `<a href="/users/${row.user_id}/details">${row.user}</a>`
           // return  routerLink(row.user_id, 'users_details', row.user)
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'shop',
        width: 90,
        title: i18n.t('label.farsi_name'),
        template:(row) => {
            return `<a href="/gateways/${row.shop_id}/details">${row.shop}</a>`
            // return  routerLink(row.shop_id, 'gateways_details', row.shop)
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'server_ip_limitation',
        width: 80,
        title: i18n.t('label.server_ip_limitation'),
        template: (row) => {
            if (row.server_ip_limitation)
                return `<i class="fa fa-check text-success fa-x2"></i>`;
            return `<i class="fa fa-times text-danger fa-x2"></i>`;
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'any_payment_limitation',
        width: 80,
        title: i18n.t('label.any_limitation_for_payment'),
        template: (row) => {
            if (row.any_payment_limitation)
                return `<i class="fa fa-check text-success fa-x2"></i>`;
            return `<i class="fa fa-times text-danger fa-x2"></i>`;
        },
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'abroad_ips_only',
        title: i18n.t('label.abroad_ips_only'),
        width: 80,
        template: (row) => {
            if (row.abroad_ips_only)
                return `<i class="fa fa-check text-success fa-x2"></i>`;
            return `<i class="fa fa-times text-danger fa-x2"></i>`;
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'limit_amount',
        title: i18n.t('label.limit_amount'),
        width: 80,
        sortable: false,
        textAlign: 'center',
    },

]